/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {useSelector} from 'react-redux';

/**
 * Provides a utility hook to know the changes that occurred in grid via
 * its respective reducer ...
 *
 * ```typescript
 *
 *   import {useHasGridChanged} from '@ion/dls/src/grid/useHasGridChanged';
 *   const hasGridChanged = useHasGridChanged('adminAsset');
 *
 * ```
 */
export const useHasGridChanged = (reducer: string): Boolean => {
  return useSelector((state) => state?.[reducer]?.grid?.hasUpdate);
};

export default useHasGridChanged;
